module.exports = __webpack_public_path__ + "img/discord-logo.1c8a54f2.svg";